import theme from 'app/util/theme';

export const imageSize = theme.spacing * 16;

export { TestID } from 'app/util/test-id';

export const valuePropositionsColumnWidth = 320;

export { theme };
